<template>
  <div class="home_wrap">
    <Header></Header>
    <van-row class="topSection">
      <van-col span="6" style="text-align: left">
        <img
          src="../images/common/backArrow.png"
          @click="$router.go(-2)"
          class="imageback"
        />
      </van-col>
      <van-col span="18" style="text-align: right">
        <span style="color: #ffffff; font-size: 30px; font-weight: 700">{{
          $t("movieInvest.topic")
        }}</span>
      </van-col>
    </van-row>
    <div class="movieContainer">
      <van-row>
        <van-col span="24">
          <img :src="data.image" class="movieTopImg" />
        </van-col>
      </van-row>

      <van-row style="padding-top: 15px">
        <van-col span="12">
          <p class="usdtAmt">
            {{
              (parseFloat(data.total) - parseFloat(data.invest_amount)).toFixed(2)
            }}
            USDT {{ $t("movieInvest.more") }}
          </p>
          <p></p>
        </van-col>
        <van-col span="12" class="remainDays"
          >{{ $t("movieInvest.remain") }} {{ data.day }}
          {{ $t("movieInvest.days") }}
        </van-col>
      </van-row>

      <van-row id="progressBar" style="padding-top: 15px">
        <van-progress
          :percentage="parseFloat(data.percent)"
          color="#d4462e"
          stroke-width="28"
        />
      </van-row>

      <van-row style="padding-top: 15px">
        <van-col span="24">
          <div style="display: flex; align-items: center">
            <img
              src="../images/home/movie.png"
              style="height: 70px; width: auto"
            />
            <div>
              <p class="movieName">{{ data[lang] }}</p>
              <div class="startSection">
                <star-rating
                  :star-size="20"
                  :animate="true"
                  :read-only="true"
                  :increment="0.01"
                  :rating="parseFloat(data.rate)"
                  style="height: 15px; width: auto; margin-right: 8px"
                />
                <img
                  @click="favorite()"
                  :src="
                    data.isFav
                      ? require('@/views/images/home/favourite.png')
                      : require('@/views/images/home/unfavourite.png')
                  "
                  style="height: 20px; width: auto"
                />
              </div>
              <p class="movieDetail">{{ data["desc_" + lang] }}</p>
            </div>
          </div>
        </van-col>
      </van-row>
    </div>
    <div class="movieContainer" style="padding: 20px 10px">
      <van-row>
        <van-col span="12">
          <p class="amountDetail">{{ $t("movieInvest.investAmount") }}</p>
          <p></p>
        </van-col>
        <van-col span="12" class="amountValue">${{data.invest_amount}}</van-col>
      </van-row>
      <van-row style="padding-top: 15px">
        <van-col span="12">
          <p class="amountDetail">{{ $t("movieInvest.shareRate") }}</p>
          <p></p>
        </van-col>
        <van-col span="12" class="amountValue">{{data.share}}%</van-col>
      </van-row>
    </div>
    <!-- <div class="movieContainer">
      <van-row style="padding: 6px">
        <van-col span="24">
          <div style="display: flex; align-items: center">
            <img
              src="../images/remove/QR.png"
              style="height: 100px; width: auto"
            />
            <div style="margin-left: 10px">
              <p class="movieInfo">{{ $t("movieInvest.transferBets") }}</p>
              <p class="movieIntro">
                {{ $t("movieInvest.transferFunds") }}
              </p>
            </div>
          </div>
        </van-col>
      </van-row>
      <van-row style="padding: 5px">
        <div class="InvestBtnBg">
          <van-col span="18">
            <p class="bettingAddr">{{ $t("movieInvest.bettingAddress") }}：</p>
            <p class="bettingAddrValue">XBWIQ23891EO21IHE1DJAJWDW0O1</p>
          </van-col>
          <van-col span="6" style="text-align: right">
            <p class="copyBtn">{{ $t("movieInvest.copy") }}</p>
          </van-col>
        </div>
      </van-row>
    </div> -->
    <!-- <van-row style="padding: 5px">
      <div class="payBtnBg" @click="showConfirmPopup">
        <van-col span="24">
          <p class="payMethod">{{ $t("movieInvest.confirm") }}</p>
        </van-col>
      </div>
    </van-row> -->
    <!-- ===================== confirm popup ============= -->
    <!-- <van-popup
      v-model="confirmPopup"
      round
      :style="{ width: '90%' }"
      :close-on-click-overlay="false"
    >
      <div style="padding: 10px 15px">
        <van-row>
          <van-col span="24" style="text-align: right">
            <img
              src="../images/common/Vector.png"
              @click="closeConfirmPopup"
              style="width: 18px"
            />
          </van-col>
        </van-row> -->
        <!-- ------------- Amount ---------------- -->
        <!-- <van-row class="amountRow">
          <van-col span="12"
            ><span class="investInfo">{{
              $t("investPopup.Amount")
            }}</span></van-col
          >
          <van-col span="12" style="text-align: right">
            <van-field v-model="amount" type="number" class="investAmount" />
          </van-col>
        </van-row> -->
        <!-- ------------- First Name ---------------- -->
        <!-- <van-row class="detailRow">
          <van-col span="12"
            ><span class="investInfo">{{
              $t("investPopup.firstName")
            }}</span></van-col
          >
          <van-col span="12" style="text-align: right">
            <span class="investInfoDetail">xxx</span>
          </van-col>
        </van-row> -->
        <!-- ------------- Family Name ---------------- -->
        <!-- <van-row class="detailRow">
          <van-col span="12"
            ><span class="investInfo">{{
              $t("investPopup.familyName")
            }}</span></van-col
          >
          <van-col span="12" style="text-align: right">
            <span class="investInfoDetail">xxx</span>
          </van-col>
        </van-row> -->
        <!-- ------------- Card Number ---------------- -->
        <!-- <van-row class="detailRow">
          <van-col span="8"
            ><span class="investInfo">{{
              $t("investPopup.cardNumber")
            }}</span></van-col
          >
          <van-col span="16" style="text-align: right">
            <span class="investInfoDetail">123152315255233142</span>
          </van-col>
        </van-row> -->
        <!-- ------------- Time to Issue ---------------- -->
        <!-- <van-row class="detailRow">
          <van-col span="12"
            ><span class="investInfo">{{
              $t("investPopup.issueTime")
            }}</span></van-col
          >
          <van-col span="12" style="text-align: right">
            <span class="investInfoDetail">2022/06/06</span>
          </van-col>
        </van-row> -->
        <!-- ------------- CVC---------------- -->
        <!-- <van-row class="detailRow">
          <van-col span="12"
            ><span class="investInfo">{{
              $t("investPopup.cvc")
            }}</span></van-col
          >
          <van-col span="12" style="text-align: right">
            <span class="investInfoDetail">xxx</span>
          </van-col>
        </van-row> -->
        <!-- ------------- Please Input Your OTP Code :---------------- -->
        <!-- <van-row class="detailRow">
          <van-col span="24"
            ><span class="investInfo">{{
              $t("investPopup.otpCode")
            }}</span></van-col
          >
        </van-row> -->
        <!-- ---------------- OTP code ------------- -->
        <!-- <van-row class="amountRow">
          <van-col span="24" style="text-align: right">
            <van-field
              v-model="otpCode"
              type="number"
              class="OTPCode"
              :placeholder="$t('investPopup.otpCodePlaceholder')"
            />
          </van-col>
        </van-row> -->
        <!-- ---------- confirm Btn -------- -->
        <!-- <van-row class="detailRow">
          <div class="payBtnBg" style="padding: 10px 0px">
            <van-col span="24">
              <p class="confirmInvest">{{ $t("investPopup.confirm") }}</p>
            </van-col>
          </div>
        </van-row>
      </div>
    </van-popup> -->
  </div>
</template>

<script>
import Vue from "vue";
import Header from "../../components/header";
import { Icon, Col, Row, Popup, Field, Progress, Toast } from "vant";
import Fetch from "../../utils/fetch";
import StarRating from "vue-star-rating";
Vue.use(Icon).use(Row).use(Col).use(Popup).use(Field).use(Progress);

export default {
  name: "movieinvest",
  components: {
    Header,
    StarRating,
  },
  data() {
    return {
      lang: this.$i18n.locale || "en_us",
      confirmPopup: false,
      amount: 0,
      otpCode: "",
      item_id: null,
      data: {},
    };
  },
  mounted() {
    this.item_id = this.$route.params.id;
    this.loadData();
  },
  methods: {
    showConfirmPopup() {
      this.confirmPopup = true;
    },
    closeConfirmPopup() {
      this.confirmPopup = false;
    },
    loadData() {
      Fetch("/movie/idUserInvests", {
        id: this.item_id,
      }).then((res) => {
        if (res.code == 1) {
          this.data = res.data;
        }
      });
    },
    favorite() {
      this.data.isFav ? this.delFav() : this.addFav();
    },
    addFav() {
      Fetch("/movie/addUserItem", {
        item_id: this.item_id,
      }).then((r) => {
        if (r.code == 1) {
          this.data.isFav = true;
          Toast.success(r.msg[this.lang]);
        } else {
          Toast.fail(r.msg[this.lang]);
        }
      });
    },
    delFav() {
      Fetch("/movie/removeUserItem", {
        item_id: this.item_id,
      }).then((r) => {
        if (r.code == 1) {
          this.data.isFav = false;
          Toast.success(r.msg[this.lang]);
        } else {
          Toast.fail(r.msg[this.lang]);
        }
      });
    },
    
  },
};
</script>

<style lang="less" scoped>
.home_wrap {
  width: 100%;
  min-height: 100vh;
  background: url("../images/common/BgImg.png");
  background-size: 100% 100%;
}

.topSection {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 20px 15px 8px;
}

.imageback {
  height: 40px;
  width: auto;
}

.movieContainer {
  padding: 10px;
  border: 2px solid #ffffff;
  border-radius: 15px;
  margin: 8px;
  background: #ebebeb29;
}

.movieTopImg {
  object-fit: fill;
  width: 100%;
}

.usdtAmt {
  color: #ffffff;
  font-size: 14px;
  border: 1px solid #ffffff;
  padding: 4px;
  border-radius: 5px;
  width: fit-content;
  text-align: center;
}

.remainDays {
  color: #ffffff;
  font-size: 14px;
  padding: 4px 0px;
  text-align: right;
}

.movieInfo {
  color: #ffffff;
  font-size: 22px;
  font-weight: 700;
  word-break: break-word;
}

.movieIntro {
  color: #d3d5d6;
  font-size: 14px;
  word-break: break-word;
  margin-top: 15px;
}

.startSection {
  display: flex;
  align-items: center;
  // justify-content: flex-end;
  margin-top: 5px;
}

.movieName {
  color: #ffffff;
  font-size: 30px;
  font-weight: 700;
}

.movieDetail {
  color: #ffffff;
  font-size: 13px;
  border: 1px solid #ffffff;
  padding: 3px;
  border-radius: 5px;
  width: fit-content;
  text-align: left;
  margin-top: 10px;
  word-break: break-word;
}

.InvestBtnBg {
  background: url("../images/common/investBtn.png");
  background-size: 100% 100%;
  align-items: center;
  display: flex;
  padding: 14px;
}

.bettingAddr {
  font-size: 12px;
  color: #000000;
  font-weight: 700;
}

.bettingAddrValue {
  font-size: 16px;
  color: #000000;
  font-weight: 700;
  margin-top: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.copyBtn {
  color: #ffffff;
  font-size: 15px;
  background: #ff0000;
  padding: 8px 20px;
  border-radius: 5px;
  width: fit-content;
  text-align: center;
  float: right;
  display: block;
  white-space: nowrap;
}
</style>
<style>
#progressBar .van-progress {
  border-radius: 20px;
}

#progressBar .van-progress__pivot {
  background-color: unset !important;
  color: #000000;
  font-size: 14px;
  /* right: 0; */
  font-weight: 700;
  /* left: unset !important; */
}

.investAmount .van-field__control {
  color: #ff0000;
  font-size: 18px;
  text-align: right;
  background: #e8eded;
  font-weight: 700;
}

.OTPCode .van-field__control {
  color: #000000;
  font-size: 14px;
  background: #e8eded;
}
.amountValue {
  color: #ffffff;
  font-size: 14px;
  text-align: right;
}
.amountDetail {
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
}
</style>
